import { useMemo } from "react"
import { useAuth } from "@/features/auth/AuthContext"

export const ASSOCIATIONS_POLICY = {
  manage: "LeninkaArt.Associations.Manage",
  verify: "LeninkaArt.Associations.Verify",
  listUnverified: "LeninkaArt.Associations.ListUnverified",
} as const

const isGranted = (policies: Record<string, boolean> | null | undefined, key: string) =>
  Boolean(policies?.[key])

export type AssociationsAccess = {
  canManage: boolean
  canVerify: boolean
  canListUnverified: boolean
  /** Любая страница админки «Ассоциации» — показываем, если есть хоть что-то из триады. */
  hasAnyAccess: boolean
}

/**
 * Динамическая роль «модератор поддерева» через ABP permissions не определяется —
 * её вычисляет бэк. На фронте доступ к очереди заявок уточняется через
 * `useAssociationsModerationNavGate` / `useEffectiveAdminAccess`.
 */
export const useAssociationsAccess = (): AssociationsAccess => {
  const { grantedPolicies, isAdmin } = useAuth()
  return useMemo(() => {
    const policies = grantedPolicies ?? {}
    const canManage = isGranted(policies, ASSOCIATIONS_POLICY.manage) || isAdmin
    const canVerify = canManage || isGranted(policies, ASSOCIATIONS_POLICY.verify)
    const canListUnverified =
      canManage || canVerify || isGranted(policies, ASSOCIATIONS_POLICY.listUnverified)
    return {
      canManage,
      canVerify,
      canListUnverified,
      hasAnyAccess: canManage || canVerify || canListUnverified,
    }
  }, [grantedPolicies, isAdmin])
}
